
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// Entities
import { Warehouse } from "@/entities/index";

@Component
export default class UpdateWarehouse extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: 0 }) myWarehouseId!: number;
  @Prop({ default: () => ({}) }) warehouse!: Warehouse;

  warehouseName = "";
  warehouseCode = "";

  @Watch("warehouse", { immediate: true, deep: true })
  onWarehouseChanged(newVal: Warehouse) {
    this.warehouseName = newVal.name || "";
    this.warehouseCode = newVal.code || "";
  }

  // ========== CRUD ========== //

  updateWarehouse(): void {
    this.$emit("update-warehouse", {
      id: this.myWarehouseId,
      name: this.warehouseName,
      code: this.warehouseCode,
    });
    this.updateWarehouseForm = false;
  }

  // ========== GETTERS & SETTERS ========== //

  get updateWarehouseForm() {
    return this.value;
  }

  set updateWarehouseForm(value: boolean) {
    this.$emit("input", value);
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.warehouseName = "";
    this.warehouseCode = "";
  }
}
